import { WordsmartClient, IssueLinkModel, Rect, WordsmartCustomRegexDTO, WordsmartCustomRegexDTORegexType } from "../Generated/ParticaAPI";
import { PageContent, PageContentItem, PageBox } from "@/Models/Components.model";

export interface IWordsmartService {
	GetWordsmartForIssue(IssueId: number): Promise<IssueLinkModel[]>;
	GetPageContent(links: IssueLinkModel[], pageNumber: number, width: number, height: number): PageContent;
	RunWordsmartPage(IssueId: number, pageNumber: number, expression: string, wstype: WordsmartCustomRegexDTORegexType): Promise<any>;
	DeleteWordsmartLink(link: IssueLinkModel): Promise<any>;
	PublishWordsmart(issueId: number): Promise<any>;
	SaveWordsmartLink(link: IssueLinkModel): Promise<any>;
}

export class WordsmartService implements IWordsmartService {
	private svc: WordsmartClient = new WordsmartClient();

	public async PublishWordsmart(issueId: number): Promise<any> {
		return await this.svc.publishLinksForIssue(issueId);
	}

	public async DeleteWordsmartLink(link: IssueLinkModel): Promise<any> {
		return await this.svc.deleteLink([link]);
	}

	public async SaveWordsmartLink(link: IssueLinkModel): Promise<any> {
		return await this.svc.saveLinks([link]);
	}

	public async GetWordsmartForIssue(IssueId: number): Promise<IssueLinkModel[]> {
		const links: IssueLinkModel[] = await this.svc.getLinksForIssue(IssueId);
		return links;
	}

	public async RunWordsmartPage(IssueId: number, pageNumber: number, expression: string, wstype: WordsmartCustomRegexDTORegexType):
		Promise<any> {
		const dto: WordsmartCustomRegexDTO = new WordsmartCustomRegexDTO();
		dto.issueId = IssueId;
		dto.pageNumber = pageNumber;
		dto.regex = expression;
		dto.regexType = wstype;
		await this.svc.wordsmartPage(dto);
	}

	public GetPageContent(links: IssueLinkModel[], pageNumber: number, width: number, height: number): PageContent {
		const content: PageContent = new PageContent();
		content.height = height;
		content.width = width;
		links.forEach(link => {
			if (link.pageNumber === pageNumber) {
				const item: PageContentItem = new PageContentItem();
				item.type = "text";
				item.class += "text";
				item.action = "link";
				item.content = link.rowKey;
				item.box = this.getbox(link.coordinates as string);
				item.box.y = height - item.box.y - item.box.height; // adjust y coords for pdf-><img>
				content.items.push(item);
			}
		});
		return content;
	}


	public async saveWordsmart() {
		throw new Error("Method not implemented.");
	}

	private getbox(coords: string): PageBox {
		const points: string[] = coords.split(",");
		const rect: Rect = new Rect();
		rect.x1 = parseFloat(points[0]);
		rect.y1 = parseFloat(points[1]);
		rect.x2 = parseFloat(points[2]);
		rect.y2 = parseFloat(points[3]);
		const box: PageBox = new PageBox(rect);
		return box;
	}


}
